import { gql } from '../../../../../hooks'

export const DELETE_ESSAY_UNITS = gql`
  mutation AdministrationDeleteSamplingEssayUnits($id: ID!) {
    aDelete(path: "sampling/essay/units", id: $id) {
    }
  }
`

export const LIST_ESSAY_UNITS = gql`
  query AdministrationListSamplingEssayUnits(
    $page: Int
    $limit: Int
    $filter: JSONObject
  ) {
    aList(
      path: "sampling/essay/units"
      filter: $filter
      page: $page
      limit: $limit
    ) {
      pagination {
        page
        limit
        number_of_pages
      }
    }
  }
`
